var _circle, _circle2, _circle3, _rect, _rect2, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanS3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.03,
    cy: 26.32,
    r: 2.97,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.41,
    cy: 68.42,
    r: 2.87,
    fill: "#e3e7fe"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.98,
    cy: 82.08,
    r: 1.72,
    fill: "#e3e7fe"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34.77,
    width: 6.88,
    height: 2.29,
    fill: "#e3e7fe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34.77,
    width: 6.88,
    height: 2.29,
    transform: "translate(44.36 27.47) rotate(90)",
    fill: "#e3e7fe"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "39.21 4.22 42.89 5.55 45.92 3.33 45.97 7.18 49.17 9.48 45.52 10.53 44.47 14.18 42.16 10.98 38.31 10.94 40.54 7.91 39.21 4.22",
    fill: "#6576ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "29.41 10.28 31.41 11 33.06 9.79 33.08 11.88 34.82 13.14 32.84 13.71 32.27 15.69 31.02 13.95 28.92 13.93 30.13 12.28 29.41 10.28",
    fill: "#b3c2ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.56 9.67 53.89 10.52 55.81 9.11 55.84 11.54 57.87 13 55.56 13.67 54.89 15.98 53.44 13.95 51 13.92 52.41 12 51.56 9.67",
    fill: "#b3c2ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.89,64.32a.77.77,0,0,0-1-.78,21.57,21.57,0,0,1-4.44.67A21.73,21.73,0,0,1,40,63.54a.77.77,0,0,0-1,.78v3a1,1,0,0,0,1,1h8.81a1,1,0,0,0,1-1Zm.46-.17",
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.43,20.88H30.92A2.08,2.08,0,0,0,28.84,23V40.1a21.46,21.46,0,0,0,4.51,13.75,14.46,14.46,0,0,0,22.65,0A21.46,21.46,0,0,0,60.51,40.1V23A2.08,2.08,0,0,0,58.43,20.88Z",
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.15,44.87c-2.71-1-4-3.51-4-7.59V27.8h4V23.85H18.31a2.07,2.07,0,0,0-2.07,2.07V37.28c0,6.93,3.16,11.15,9,12.14a26.26,26.26,0,0,1-1.06-4.55Z",
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,72.92v2.16c0,.23.94.42,2.1.42H58.4c1.16,0,2.1-.19,2.1-.42V72.92c0-.23-.94-.42-2.1-.42H30.6C29.44,72.5,28.5,72.69,28.5,72.92Zm2.85.12",
    fill: "#6576ff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,78.92v2.16c0,.23.94.42,2.1.42H58.4c1.16,0,2.1-.19,2.1-.42V78.92c0-.23-.94-.42-2.1-.42H30.6C29.44,78.5,28.5,78.69,28.5,78.92Zm2.85.12",
    fill: "#6576ff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.64,23.85H65.71V27.8h4v8.84c0,3.89-1.24,6.22-4,7.23a24,24,0,0,1-1.06,4.33c5.81-.94,9-5,9-11.56V25.82a2,2,0,0,0-2-2Z",
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.56,33.64v9a1.45,1.45,0,0,1-.72,1.26L45.4,46.48a1.45,1.45,0,0,1-1.45,0l-4.43-2.56a1.44,1.44,0,0,1-.73-1.26V37.54a1.44,1.44,0,0,1,.73-1.26L44,33.72a1.43,1.43,0,0,1,1.32-.07v1.52l0,0a1.14,1.14,0,0,0-1.13,0l-3.44,2a1.11,1.11,0,0,0-.56,1v4a1.12,1.12,0,0,0,.56,1l3.44,2a1.14,1.14,0,0,0,1.13,0l3.44-2a1.12,1.12,0,0,0,.56-1v-9.2Z",
    fill: "#6576ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.92,32.11l-1.33-.76v1.53h0v8a.49.49,0,0,1-.24.42l-1.43.83a.51.51,0,0,1-.48,0L43,41.35a.49.49,0,0,1-.24-.42V39.27a.49.49,0,0,1,.24-.42L44.44,38a.46.46,0,0,1,.48,0l.35.21V36.7l-.19-.11a.79.79,0,0,0-.81,0L41.84,38a.82.82,0,0,0-.41.7V41.5a.81.81,0,0,0,.41.7l2.43,1.41a.83.83,0,0,0,.81,0l2.43-1.41a.81.81,0,0,0,.41-.7V33.64h0Z",
    fill: "#6576ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.89,34.41v8.82a1.78,1.78,0,0,1-.9,1.55l-5.42,3.13a1.79,1.79,0,0,1-1.79,0l-5.42-3.13a1.78,1.78,0,0,1-.9-1.55V37a1.78,1.78,0,0,1,.9-1.55l5.42-3.13a1.79,1.79,0,0,1,1.79,0l1,.59V31.35l-.86-.5a2.1,2.1,0,0,0-2.11,0L37.2,34.56a2.11,2.11,0,0,0-1.06,1.83v7.42a2.11,2.11,0,0,0,1.06,1.83l6.42,3.7a2.1,2.1,0,0,0,2.11,0l6.42-3.7a2.11,2.11,0,0,0,1.06-1.83V35.19Z",
    fill: "#6576ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanS3);
export default __webpack_public_path__ + "static/media/plan-s3.b076cdfb5f4f9fbd581fc51c17f12469.svg";
export { ForwardRef as ReactComponent };